// extracted by mini-css-extract-plugin
export var modal = "_du-0";